module.exports = __webpack_public_path__ + "static/media/link.e8a75693.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link.svg
// module id = 77
// module chunks = 0